
import React from "react";

const GoogleLinkRenderer = (props) => {
  const url = `https://www.google.com/search?tbm=isch&q=${encodeURIComponent(props.value)}`;
  return (
    <button className="image-link-button"
      onClick={() => window.open(url, "_blank", "noopener,noreferrer")}
      
    >
       Google ↗
    </button>
  );
};

export default GoogleLinkRenderer;





